import styled from '../../../../theme'

const StatusColor = styled.div<IStatusColorProps>`
  display: flex;
  width: ${({ size }) => (size ? 30 * size : 30)}px;
  height: ${({ size }) => (size ? 30 * size : 30)}px;
  min-height: ${({ size }) => (size ? 30 * size : 30)}px;
  min-width: ${({ size }) => (size ? 30 * size : 30)}px;
  border-radius: 50%;
  background-color: ${props => props.color};
  color: #fff;
  align-items: center;
  justify-content: center;
  margin: ${({ size }) => (size ? 7 * size : 7)}px
    ${({ size }) => (size ? 9 * size : 9)}px
    ${({ size }) => (size ? 7 * size : 7)}px
    ${({ size }) => (size ? 15 * size : 15)}px;
`

export default StatusColor

export interface IStatusColorProps {
  color: string | any
  size?: number
}
